import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { Asset } from "@/types/assets";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getAsset = async (assetId: string): Promise<Asset> => {
  const { data } = await axiosInstance.get(`/v1/assets/${assetId}`);
  return data;
};

export const uploadAsset = async (
  file: Blob,
  filename = "image"
): Promise<{ id: string }> => {
  try {
    const form = new FormData();
    form.append("file", file, filename);
    const { data } = await axiosInstance.post<{ id: string }>(
      "/v1/assets",
      form,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    throw new CustomError(message, status);
  }
};
